export default __webpack_public_path__ + "static/media/default-company.b55e6ea4.png";